import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Expertise, ExpertiseCategory } from 'src/app/models/community';
import { CommunityService } from 'src/app/services/community.service';
import { I18nService } from 'src/app/services/i18n.service';
import { categoryLabelKey, formatDate } from '../account-sections';

@Component({
  selector: 'app-user-expertise',
  templateUrl: './user-expertise.component.html',
  styleUrls: ['./user-expertise.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class UserExpertiseComponent implements OnInit {

  readonly steps = [
    { icon: 'workspace_premium', key: 'how1' },
    { icon: 'update', key: 'how2' },
    { icon: 'forum', key: 'how3' },
    { icon: 'label', key: 'how4' },
  ];

  expertise: Expertise | null = null;
  loading = true;
  error = '';

  constructor(private communityService: CommunityService, public i18n: I18nService) { }

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loading = true;
    this.error = '';
    this.communityService.expertise().subscribe({
      next: expertise => {
        this.expertise = expertise;
        this.loading = false;
      },
      error: err => {
        this.error = err || this.i18n.t('account.loadError');
        this.loading = false;
      }
    });
  }

  get expertCategories(): ExpertiseCategory[] {
    return this.expertise?.categories.filter(c => c.expert) || [];
  }

  categoryName(category: string): string {
    const key = categoryLabelKey(category);
    return key ? this.i18n.t(key) : category;
  }

  progress(category: ExpertiseCategory): number {
    if (!this.expertise) {
      return 0;
    }
    const deals = Math.min(1, category.deals / this.expertise.minDeals);
    const hot = Math.min(1, category.hot / this.expertise.minHot);
    return Math.round(((deals + hot) / 2) * 100);
  }

  date(value: string): string {
    return formatDate(value, this.i18n.current);
  }
}
